export default class AppStartCacheService {
    /* @ngInject */
    constructor($q, storageService) {
        this.$q = $q;
        this.storageService = storageService;
        this.entries = [];
        this.inflight = null;
        this.completed = false;
    }

    register(key, handler) {
        const normalized = this.normalizeHandler(handler);

        if (!key || !normalized) {
            return null;
        }

        this.entries.push({
            key,
            handler: normalized
        });

        return null;
    }

    reset() {
        this.inflight = null;
        this.completed = false;
    }

    warm() {
        if (this.inflight) {
            return this.inflight;
        }

        if (this.completed) {
            return this.$q.resolve([]);
        }

        const tasks = this.entries.map((entry) => this.$q.when().then(() => entry.handler.warm()).catch(() => null));
        this.inflight = this.$q.all(tasks).finally(() => {
            this.completed = true;
            this.inflight = null;
        });

        return this.inflight;
    }

    clearAll() {
        this.entries.forEach((entry) => {
            if (entry.handler && entry.handler.clear) {
                entry.handler.clear();
            }
        });
    }

    clearUserKeyPrefix(prefix) {
        if (!this.storageService.userPrefix || !prefix) {
            return null;
        }

        const storage = this.storageService.getStorage();
        const base = this.storageService.getPrefixedKey(this.storageService.prefix, this.storageService.userPrefix);
        const normalizedPrefix = this.storageService.normalizeKey(prefix);
        const fullPrefix = `${base}-${normalizedPrefix}`;

        for (let index = storage.length - 1; index >= 0; index -= 1) {
            const key = storage.key(index);
            if (key && key.startsWith(fullPrefix)) {
                storage.removeItem(key);
            }
        }

        return null;
    }

    normalizeHandler(handler) {
        if (typeof handler === 'function') {
            return {
                warm: handler,
                clear: null
            };
        }

        if (handler && typeof handler.warm === 'function') {
            return {
                warm: handler.warm,
                clear: typeof handler.clear === 'function' ? handler.clear : null
            };
        }

        return null;
    }
}



// WEBPACK FOOTER //
// ./src/application/service/app-start-cache.service.js